// extracted by mini-css-extract-plugin
module.exports = {"Concrete":"#F3F3F3","divider":"Divider_divider__CVK3Q"};